'use strict';

var Marionette = require('backbone.marionette');

export default Marionette.View.extend({

  tagName: 'li',
  template: require('./templates/selected-service-item.hbs'),
  triggers: {
    'click .fa-close': 'close',
  },

  serializeData: function () {
    var json = this.model.toJSON();
    json.currency = window.SETTINGS.currency;
    json.notFree = this.model.showPrice();
    return json;
  },

});
